module.exports = __webpack_public_path__ + "static/media/VehicleStatBlock.31dfa3a5.svg";